(function () {
  'use strict';

  function initReveal(root) {
    if (!root || root.getAttribute('data-ne-initialized')) return;
    root.setAttribute('data-ne-initialized', 'true');

    var revealEls = root.querySelectorAll('.ne-reveal:not(.ne-in)');
    if (revealEls.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('ne-in');
                io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
        );
        revealEls.forEach(function (el, i) {
          el.style.transitionDelay = Math.min(i % 6, 5) * 0.06 + 's';
          io.observe(el);
        });
      } else {
        revealEls.forEach(function (el) { el.classList.add('ne-in'); });
      }
    }

    // ---------- exhibition tabs (Upcoming / Past) ----------
    var tabBtns = root.querySelectorAll('[data-ne-tab-btn]');
    if (tabBtns.length) {
      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-ne-tab-btn');

          tabBtns.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('ne-tab-btn--active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          root.querySelectorAll('[data-ne-tab-panel]').forEach(function (panel) {
            var match = panel.getAttribute('data-ne-tab-panel') === target;
            panel.classList.toggle('ne-tab-panel--active', match);
            if (match) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('.naseebo-events, .naseebo-exhibitions').forEach(initReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.naseebo-events, .naseebo-exhibitions');
    if (root) initReveal(root);
  });
})();